// initial state
import * as base from './base.js'
const shorturlName = '/admin/api/shorturl'

const obj = base.setBaseUrl('shorturl', shorturlName)
const a = Object.assign(obj)
export default a
